<template>
  <div class="c-toolbar flex items-center" role="toolbar">
    <div class="w-[33.3333%] flex">
      <slot name="left"></slot>
    </div>
    <div class="justify-center w-[25%] flex">
      <slot name="center"></slot>
    </div>
    <div class="justify-end w-[41.6667%] flex">
      <slot name="right"></slot>
    </div>
  </div>
</template>
<script setup lang="ts">
import type { VNode } from 'vue';

defineOptions({ name: 'Toolbar' });

defineSlots<{
  left(): VNode[];
  center(): VNode[];
  right(): VNode[];
}>();
</script>
